import { Pipe, PipeTransform } from '@angular/core';
import { AssetFilter } from 'app/services/assets/asset-filter.service';

@Pipe({
    name: 'isFiltering',
})
export class isFilteringPipe implements PipeTransform {

    transform(filter: AssetFilter): boolean {
        if (filter) {
            return Object.keys(filter)?.length > 0;
        }
        return false;
    }

}
